export default "__VITE_ASSET__DCzkz98L__"